module.exports = __webpack_public_path__ + "img/newInt-activateBtn.8ea047cd.svg";